import { createContext, useContext } from 'react';

import type { OrganizationContextType } from './organization-types';

export type { OrganizationMemberWithProfile } from './organization-types';

export const OrganizationContext = createContext<OrganizationContextType | undefined>(undefined);

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (context === undefined) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
};
